import { TIMEOUT } from "../constants";

export type GetCloudStatus = () => Promise<boolean>;

export type PollCloudStatusOptions = {
    readonly getCloudStatus: GetCloudStatus;
    readonly onError: (
        startTime: number,
        endTime: number,
        elapsedTime: number,
        error: unknown
    ) => void;
    readonly onSuccess: (
        startTime: number,
        endTime: number,
        elapsedTime: number
    ) => void;
    readonly onTimeout: (
        startTime: number,
        endTime: number,
        elapsedTime: number
    ) => void;
    readonly startTime: number;
};

export function pollCloudStatus(options: PollCloudStatusOptions): void {
    const { getCloudStatus, onError, onSuccess, onTimeout, startTime } =
        options;
    const endTime = Date.now();
    const elapsedTime = endTime - startTime;
    if (elapsedTime < TIMEOUT) {
        getCloudStatus()
            .then((ready) => {
                if (ready) {
                    onSuccess(startTime, endTime, elapsedTime);
                } else {
                    setTimeout(() => pollCloudStatus(options), 5000);
                }
            })
            .catch((error) => onError(startTime, endTime, elapsedTime, error));
    } else {
        onTimeout(startTime, endTime, elapsedTime);
    }
}
